import { ReactNode } from 'react'
import { Drawer as BaseDrawer, DrawerProps as BaseDrawerProps } from 'antd'

export interface DrawerProps extends Omit<BaseDrawerProps, 'children'> {
  children?: ReactNode
}

export const Drawer = (props: DrawerProps): JSX.Element => (
  <>
    <BaseDrawer {...props} />
  </>
)
